import React, { useEffect, useState } from 'react';
import './layout.css';
import AuthService from "../../services/auth/auth.service"
import authService from '../../services/auth/auth.service';
import { useLocation } from 'react-router-dom';
import contactsService from '../../services/contractor/contacts.service';
import { FormControl, FormControlLabel, InputAdornment, InputBase, Switch, TextField } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import SearchIcon from "@mui/icons-material/Search";
const ContrastColor = require('contrast-color');



function Header() {

  let location = useLocation();



  let locationkey = location.pathname.replaceAll('/', '')
  
  if (locationkey.indexOf("contractorscard")>=0){
    locationkey = "contractorscard"
  }

  const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationkey + '-search'
  const LOCAL_STORAGE_SEARCH_INCOGNITO = authService.getCurrentUser()?.shrt + '_crm-' + locationkey + '-incognito-search'
  const [searchQuery, setsearchQuery] = useState("");

  const search_key =  authService.getCurrentUser()?.shrt + '_crm-' + locationkey + '-search'
  const search_contractors = authService.getCurrentUser()?.shrt + '_crm-' + 'contractors-search'

  const [searchContacts, setSearchContacts] = useState([])

  


  const onSerchContractors = () => {
    //console.log(localStorage[search_key]) 
    contactsService.searchContacts(localStorage[search_key]).then(
      (result => {
        //console.log(result)
        setSearchContacts(result)
      })

    ).catch(
      (error => {
        setSearchContacts([])
      })
    ) 
  };

 
  const onFocus = () => {
    window.addEventListener("serchcontractors",onSerchContractors)  
  };
  const onBlur = () => {
    window.removeEventListener("serchcontractors",onSerchContractors) 
  };
    

  useEffect(()=>{
    if ( localStorage[LOCAL_STORAGE_SEARCH]){
      setsearchQuery(localStorage[LOCAL_STORAGE_SEARCH])  
    }
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);
    onFocus();

   

  }, []) 

  const handleKeyDown = (e : React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      //console.log($('#incognito_switch'))
      //console.log($('#incognito_switch').is(':checked'))
     // console.log(LOCAL_STORAGE_SEARCH)
      if ($('#incognito_switch') && $('#incognito_switch').is(':checked')){
          var val : string = $('#input-search-query1').val() as string;
          
          if (val === ''){
            localStorage.removeItem(LOCAL_STORAGE_SEARCH_INCOGNITO)
          }else{
            localStorage.setItem(LOCAL_STORAGE_SEARCH_INCOGNITO, val)
          }
          window.dispatchEvent(new Event('storage'))
      }else{
          var val : string = $('#input-search-query1').val() as string;
          
          if (val === ''){
            localStorage.removeItem(LOCAL_STORAGE_SEARCH)
          }else{
            if (LOCAL_STORAGE_SEARCH.indexOf('contractorscard-search')>=0){
              localStorage.setItem(search_contractors, val)
              window.location.replace("/contractors?allsearch=true")  
            }else{
              localStorage.setItem(LOCAL_STORAGE_SEARCH, val)
            }
          }
          window.dispatchEvent(new Event('storage'))
      }
    }
  };
    
  const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
    
    setsearchQuery(event.target.value)
  };

  const handleClearSearch = (event: React.MouseEvent<HTMLElement>) => {
    $('#input-search-query1').val('')
    setsearchQuery('')
    localStorage.removeItem(LOCAL_STORAGE_SEARCH)
    window.dispatchEvent(new Event('storage'))
  }


  const handlelogout = (event: { preventDefault: () => void; }) => {
    //Prevent page reload
    event.preventDefault();

    AuthService.logout();
    window.location.href = '/'  
  };

    var user = AuthService.getCurrentUser()
    var username : string | undefined =''
    
    var shrt: string = '';
    var ucolor: string = '';
    var perms: string = "";

    if (user){
       username=user.name; 
       shrt=user.shrt;
       ucolor=user.ucolor; 
       perms=user.g_name; 

    }
  return (
    <div>
      {/* Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#" onClick={(e) => window.dispatchEvent(new Event('resize'))} role="button"><i className="fas fa-bars" /></a>
          </li>
          <li>
           


<FormControl className={"search"}>
        <TextField
          size="small"
          variant="outlined"
          onChange={handleChangeSearch}
          onKeyDown={handleKeyDown}
           id="input-search-query1"
           value={searchQuery}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment
                position="end"
                style={{ display: "showClearIcon", cursor:"pointer" }}
                onClick={handleClearSearch}

                
              >
                <ClearIcon />
              </InputAdornment>
            )
          }}
        />

       
      </FormControl>
     
              </li>
         
          
        </ul>
        
        {/* Right navbar links */}
          <ul className="navbar-nav ml-auto">

          {/* Messages Dropdown Menu */}
          <li className="nav-item dropdown">
            <a className="nav-link" data-toggle="dropdown" href="#">
              <i className="fa fa-phone" />
              <span className="badge badge-danger navbar-badge">{searchContacts.length}</span>
            </a>
            <div className="dropdown-menu  dropdown-menu-right" style={{maxHeight:600, overflow:'auto'}}>
              
                
                {searchContacts.map(function(item:any, i){
                        var tmp = '/contractors/card/' + item.contractor_id;
                        return  <><a href={tmp} className="dropdown-item" >
                                    {/* Message Start */}
                                    <div className="media">
                                      <img src="/dist/img/searchUsr1.png" alt="User Avatar" className="img-size-50 img-circle mr-3" />
                                      <div className="media-body">
                                        <h3 className="dropdown-item-title">
                                          {item.name}
                                          <span className="float-right text-sm text-muted"></span>
                                        </h3>
                                        <a className="text-sm">{item.contractor_name}</a>
                                        <p className="text-sm text-muted"><i className="fa fa-phone" /> {item.phone} <br/>
                                        <i className="fa fa-envelope" /> {item.mail}</p>
                                      
                                      </div>
                                    </div>
                                    {/* Message End */}
                                  </a>
                                  <div className="dropdown-divider" />
                                </>
                    })
                }
               
            </div>
          </li>
          {/* Notifications Dropdown Menu */}
          <li className="nav-item dropdown">
            <a className="nav-link" data-toggle="dropdown" href="#">
              <i className="far fa-bell" />
              <span className="badge badge-warning navbar-badge">15</span>
            </a>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              <span className="dropdown-item dropdown-header">15 Notifications</span>
              <div className="dropdown-divider" />
              <a href="#" className="dropdown-item">
                <i className="fas fa-envelope mr-2" /> 4 new messages
                <span className="float-right text-muted text-sm">3 mins</span>
              </a>
              <div className="dropdown-divider" />
              <a href="#" className="dropdown-item">
                <i className="fas fa-users mr-2" /> 8 friend requests
                <span className="float-right text-muted text-sm">12 hours</span>
              </a>
              <div className="dropdown-divider" />
              <a href="#" className="dropdown-item">
                <i className="fas fa-file mr-2" /> 3 new reports
                <span className="float-right text-muted text-sm">2 days</span>
              </a>
              <div className="dropdown-divider" />
              <a href="#" className="dropdown-item dropdown-footer">See All Notifications</a>
            </div>
          </li>
          <li className="nav-item dropdown user-menu">
            <a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown">
              <span style={{backgroundColor:ucolor, color:new ContrastColor(ucolor)}} className="gavatar_m" >{shrt}</span> 
              <span className="d-none d-md-inline">{username}</span>
            </a>
            <ul className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              {/* User image */}
              <li className="user-header bg-primary">
                
                <span style={{backgroundColor:ucolor, color:new ContrastColor(ucolor)}} className="gavatar_l" >{shrt}</span>
                
                <p>
                  {username} - {perms}
                  <small>Expo Property BIS SC</small>
                </p>
              </li>
              {/* Menu Body */}
              
              {/* Menu Footer*/}
              <li className="user-footer">
                <a href="/changepassword" className="btn btn-default btn-flat">Zmień hasło</a>
                <a href="#" onClick={handlelogout} className="btn btn-default btn-flat float-right">Wyloguj</a>
              </li>
            </ul>
          </li>

          <li className="nav-item">
            <a className="nav-link" data-widget="fullscreen" href="#" role="button">
              <i className="fas fa-expand-arrows-alt" />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-widget="control-sidebar" data-controlsidebar-slide="true" href="#" role="button">
              <i className="fas fa-th-large" />
            </a>
          </li>
        </ul>
      </nav>
      {/* /.navbar */}
    </div>

  );
}

export default Header;